export const DOCUMENT_COUNTS_ORDER = [
  "documentCount",
  "shreddingCount",
  "researchCount",
  "amendmentCount",
  "hasTechnicalAlignment",
];

export const TITLE = "Opportunity to Proposal";
export const SUBTITLE =
  "Whether an opportunity has a proposal, plus its documents, research docs, shreds, compare docs and technical alignment";
export const HAS_PROPOSAL_LABEL = "Has proposal";
export const NO_PROPOSAL_LABEL = "No proposal";
export const WIDGET_ROWS_LIMIT = 3;
export const EMPTY_TITLE = "No Tracked Opportunities";

export const EMPTY_BODY =
  "There are no active tracked opportunities for the selected period.";
export const moreLabel = (n) =>
  `${n} more ${n === 1 ? "opportunity" : "opportunities"}`;
export const viewAllLabel = (n) =>
  `View all ${n} ${n === 1 ? "opportunity" : "opportunities"}`;
